// extracted by mini-css-extract-plugin
export var crumb = "Breadcrumbs-mps-module--crumb--8b6d1";
export var lastCrumb = "Breadcrumbs-mps-module--lastCrumb--6de9a";
export var root = "Breadcrumbs-mps-module--root--b7a5f";
export var spacer = "Breadcrumbs-mps-module--spacer--ef449";